/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"14\"><path fill-rule=\"evenodd\" d=\"M13.5 0h-12C.673 0 0 .673 0 1.5V5h1V1.5a.5.5 0 01.5-.5H7v12H4v1h7v-1H8V1h5.5a.5.5 0 01.5.5V5h1V1.5c0-.827-.673-1.5-1.5-1.5\"/></svg>\n";
//# sourceMappingURL=text.svg.js.map